import { startOfYear, endOfYear, subYears, addYears, format } from "date-fns";

const lastYearToCurrentYear = (value) => {
  const currentDate = new Date();

  // Start of the year "value - 1" years ago
  const startDate = startOfYear(subYears(currentDate, Number(value) - 1));

  // End of the current year
  const endDate = endOfYear(currentDate);

  // Format the dates
  const formattedStartDate = format(startDate, "dd/MM/yyyy");
  const formattedEndDate = format(endDate, "dd/MM/yyyy");
  const dates = { formattedStartDate, formattedEndDate };
  return dates;
};

const currentYearToNextYear = (value) => {
  const currentDate = new Date();

  // Start of the current year
  const startDate = startOfYear(currentDate);

  // End of the "value - 1" years in the future
  const endDate = endOfYear(addYears(currentDate, Number(value) - 1));

  // Format the dates
  const formattedStartDate = format(startDate, "dd/MM/yyyy");
  const formattedEndDate = format(endDate, "dd/MM/yyyy");
  const dates = { formattedStartDate, formattedEndDate };
  return dates;
};

const fromThisYearToThisYear = (value) => {
  const currentDate = new Date();

  let startDate;
  let endDate;

  if (value === "Last Year") {
    startDate = startOfYear(subYears(currentDate, 1)); // Start of last year
    endDate = endOfYear(subYears(currentDate, 1)); // End of last year
  } else if (value === "This Year") {
    startDate = startOfYear(currentDate); // Start of this year
    endDate = endOfYear(currentDate); // End of this year
  } else if (value === "Next Year") {
    startDate = startOfYear(addYears(currentDate, 1)); // Start of next year
    endDate = endOfYear(addYears(currentDate, 1)); // End of next year
  } else {
    console.error(
      "Invalid value, please use 'Last Year', 'This Year', or 'Next Year'"
    );
  }

  // Format the dates
  if (startDate && endDate) {
    const formattedStartDate = format(startDate, "dd/MM/yyyy");
    const formattedEndDate = format(endDate, "dd/MM/yyyy");
    return { formattedStartDate, formattedEndDate };
  } else {
    console.log("start and end date is undefined");
  }
};

export { lastYearToCurrentYear, currentYearToNextYear, fromThisYearToThisYear };
